import { PageTemplate } from "components";
import MobileTemplate from "components/MobileTemplate";
import { useMediaQuery } from "react-responsive";

interface PageContainerType {
    MobileView: JSX.Element | JSX.Element[];
    DesktopView: JSX.Element | JSX.Element[];
    groupeName?: string;
    title?: string;
    listOfTitles?: Array<string>;
    withoutBackgroundMobile?: boolean;
    customBody?: string;
}

const PageContainer: React.FC<PageContainerType> = ({
    MobileView,
    DesktopView,
    groupeName,
    title,
    listOfTitles,
    withoutBackgroundMobile,
    customBody,
}) => {
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 992px)" });

    return (
        <>
            {isTabletOrMobile ? (
                <MobileTemplate
                    withoutBackground={withoutBackgroundMobile}
                    customBody={customBody}
                    title={title}
                >
                    {MobileView}
                </MobileTemplate>
            ) : (
                <PageTemplate
                    isNewBackground
                    groupName={groupeName ?? ""}
                    title={title ?? ""}
                    listOfTitles={listOfTitles}
                >
                    {DesktopView}
                </PageTemplate>
            )}
        </>
    );
};

export default PageContainer;
